// extracted by mini-css-extract-plugin
export default {"content":"Text_content__Ruxs8"};